import * as React from "react";
import { Pagination } from "react-admin";
import { DefaultRowsPerPageOptions } from "../../Constants/Constant";

export const PoolPagination = props => {
  return <Pagination rowsPerPageOptions={DefaultRowsPerPageOptions} {...props} />;
};
export default PoolPagination;
